import { Component } from '@angular/core';
import {FaqService} from "../../gestao/services/faq.service";
import {Faq} from "../../gestao/models/faq";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-lista-faq',
    templateUrl: './lista-faq.component.html',
    styleUrl: './lista-faq.component.css',
    standalone: false
})
export class ListaFaqComponent {
  visualizarFaq = false;
  loading = true;
  faq: Faq;
  listaFaqs: Faq[] = [];
  filtro = '';

  constructor(private faqService: FaqService,
              private toastr: ToastrService) {
    this.buscarListaMaisAcessados();
  }

  public setarFaq(id: number) {
    let faq = this.listaFaqs.find(x => x.id == id);

    if(faq != undefined)
      this.faq = faq;

    this.visualizarFaq = true;
  }

  public buscarFiltro(){
    this.loading = true;
    this.faqService.buscarPorFiltro(this.filtro).subscribe(resultado => {
      if(resultado.sucesso)
        this.listaFaqs = resultado.dados;
      else
        this.toastr.warning("Não foi encontrado nenhuma ajuda com o termo pesquisado");

      this.loading = false;
    }, (error) => {
      this.toastr.error("Não foi encontrado nenhuma ajuda com o termo pesquisado");
      this.loading = false;
    });

  }

  public fecharVisualizar(){
    this.faq = new Faq();
    this.visualizarFaq = false;
  }

  private buscarListaMaisAcessados(){
    this.loading = true;
    this.faqService.buscarMaisAcessados().subscribe(resultado =>{
      if(resultado.sucesso){
        this.listaFaqs = resultado.dados;
      }
      this.loading = false;
    }, error =>{
      this.loading = false;
    });

  }
}
